<template>
  <div>
    <v-card outlined>
      <v-card-subtitle>{{ $t("Administrator") }}</v-card-subtitle>
      <v-card-text>
        <v-text-field
          v-bind:label="$t('Name')"
          v-model="wizard.roles[0].name"
        ></v-text-field>
      </v-card-text>
    </v-card>
    <v-row
      justify="center"
      align="center"
      class="pt-5"
      v-if="roleList.length == 0"
    >
      <div class="text-center">
        <v-btn small @click="add" color="primary">
          {{ $t("Add") }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </v-row>
    <v-row v-for="(role, index) in roleList" :key="index">
      <v-col cols="8" md="10">
        <v-text-field
          v-bind:label="$t('Name')"
          type="text"
          v-model="role.name"
        />
      </v-col>
      <v-col cols="4" md="2">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" color="error" icon @click="remove(index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Delete") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              color="success"
              icon
              @click="add"
              v-if="showAdd(index)"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Add") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Role from "@/ecm/models/Role";
export default {
  props: {
    wizard: {
      type: Object,
      default: () => ({}),
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {},
  computed: {
    roleList() {
      return this.wizard.roles.filter((role) => !role.isOrganizationAdmin);
    },
  },
  methods: {
    add() {
      this.wizard.roles.push(new Role());
    },
    remove(index) {
      this.wizard.roles.splice(index + 1, 1);
    },
    showAdd(index) {
      return index == this.roleList.length - 1;
    },
  },
};
</script>

<style>
</style>